// 真是接口和转盘指针的对应关系
// key是接口返回的参数，value是转盘的位置，从0到7开始
// key对应关系
// 0: '未抽奖'
// 1: '抽奖中'
// 2: '抽奖失败'
// 10: '未中奖'
// 11 : '1云豆'
// 12 : '2云豆'
// 13 : '5云豆'
// 14 : '10云豆'
// 15 : '100云豆'
// 16 : '500云豆'
// 17 : '1000云豆'

// value对应关系（转盘位置）
// 0:'100云豆',
// 1: '2云豆', 
// 2: '谢谢参与'
// 3: '500云豆',
// 4: '10云豆', 
// 5: '1云豆', 
// 6: '1000云豆'
// 7: '5云豆',
export const opResult = {
    0 : 2,
    1 : 2,
    2 : 2,
    10 : 2,
    11 : 5,
    12 : 1,
    13 : 7,
    14 : 4,
    15 : 0,
    16 : 3,
    17 : 6,
};

// 这是后台返回的参数和真正云豆的对应关系
// 0: '未抽奖'
// 1: '抽奖中'
// 2: '抽奖失败'
// 10: '未中奖'
// 11 : '1云豆'
// 12 : '2云豆'
// 13 : '5云豆'
// 14 : '10云豆'
// 15 : '100云豆'
// 16 : '500云豆'
// 17 : '1000云豆'
export const yundouResult = {
    0 : 0,
    1 : 0,
    2 : 0,
    10 : 0,
    11 : 1,
    12 : 2,
    13 : 5,
    14 : 10,
    15 : 100,
    16 : 500,
    17 : 1000,
};


export const content = [
    '用户8*****2获得5云豆',
    '用户8*****2获得10云豆',
    '用户8*****6获得2云豆',
    '用户7*****0获得100云豆',
    '用户8*****2获得100云豆',
    '用户6*****1获得100云豆',
    '用户7*****6获得10云豆',
    '用户6*****4获得5云豆',
    '用户6*****8获得5云豆',
    '用户8*****8获得2云豆',
];

